import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { retrieveOfferByIdApi } from "../../../../components/api/OfferApiService";

const OfferButton = ({ row, setEditOffer }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return; 
    setLoading(true);
    try {
      const offerData = await retrieveOfferByIdApi(row?.offerId);
      if (!offerData) {
        alert("No data returned from the API.");
        return;
      }
      setEditOffer({
        visible: true,
        data: offerData?.data,
        index: row?.index,
      });
      console.log(offerData);
    } catch (error) {
      console.error("Error retrieving offer:", error);
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Button
      sx={{
        minWidth: 0,
        padding: "2px 4px",
        fontSize: "0.8rem",
        lineHeight: 1,
      }}
      onClick={handleClick}
      variant="text"
      disabled={loading}
      startIcon={loading && <CircularProgress size={16} />}
    >
      {row?.offerId}
    </Button>
  );
};

export default OfferButton;
